module.exports = __webpack_public_path__ + "static/media/connectguide4.a60662b2.png";